import { motion } from "framer-motion";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-paris-stone overflow-x-hidden" data-testid="privacy-page">
      {/* Hero */}
      <section className="bg-midnight-navy pt-24 pb-12 md:pt-28 md:pb-16">
        <div className="container mx-auto px-4 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading font-bold text-3xl md:text-4xl text-white mb-3 md:mb-4">
              Privacy Policy
            </h1>
            <p className="text-paris-stone/70 text-sm md:text-base">Last updated: January 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-16 bg-paris-stone">
        <div className="container mx-auto px-4 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl shadow-soft p-5 md:p-10"
          >
              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                1. Information We Collect
              </h2>
              <p className="text-slate-600 mb-6">
                We collect information you provide directly to us when making a booking, including:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
                <li>Name, email address, and phone number</li>
                <li>Pickup and drop-off locations</li>
                <li>Travel dates and times</li>
                <li>Flight information (when applicable)</li>
                <li>Payment method preference</li>
                <li>Special requests or notes</li>
              </ul>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                2. How We Use Your Information
              </h2>
              <p className="text-slate-600 mb-6">
                We use the information we collect to:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
                <li>Process and manage your booking</li>
                <li>Communicate with you about your transfer</li>
                <li>Provide customer support</li>
                <li>Send booking confirmations and updates</li>
                <li>Improve our services</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                3. Information Sharing
              </h2>
              <p className="text-slate-600 mb-6">
                We share your information only with:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
                <li>Our drivers to complete your transfer</li>
                <li>Service providers who assist our operations</li>
                <li>Legal authorities when required by law</li>
              </ul>
              <p className="text-slate-600 mb-6">
                We do not sell your personal information to third parties.
              </p>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                4. Data Security
              </h2>
              <p className="text-slate-600 mb-6">
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction.
              </p>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                5. Your Rights (GDPR)
              </h2>
              <p className="text-slate-600 mb-6">
                Under the General Data Protection Regulation (GDPR), you have the right to:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
                <li>Access your personal data</li>
                <li>Rectify inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing</li>
                <li>Data portability</li>
                <li>Withdraw consent at any time</li>
              </ul>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                6. Cookies
              </h2>
              <p className="text-slate-600 mb-6">
                We use cookies to improve your experience on our website. You can control 
                cookie settings through your browser preferences.
              </p>

              <h2 className="font-heading font-bold text-2xl text-slate-900 mb-4">
                7. Contact Us
              </h2>
              <p className="text-slate-600 mb-4">
                For any privacy-related questions or to exercise your rights, contact us at:
              </p>
              <p className="text-slate-600">
                <strong>Email:</strong> privacy@bestdisneytransfer.com<br />
                <strong>Phone:</strong> +33 1 23 45 67 89
              </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
